import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { colorProfileByIndex } from '@powdr/utils';

import {
  StyledBookingWidget,
  StyledDesktopTabGroup,
} from './styles';
import { BookingWidgetTab } from './tab';
import { TabContent } from './tabContent';

export const BookingWidget = ({
  relationships,
  colorProfile,
  parentColorProfile,
  is5050,
}) => {
  const { tabs } = relationships;
  const [activeTab, setActiveTab] = useState(0);
  const trueColorProfile = (colorProfile) ? colorProfileByIndex(colorProfile) : parentColorProfile;

  return (
    <StyledBookingWidget className="booking-widget" colorProfile={trueColorProfile}>
      {/* Tabs for larger screens */}
      <StyledDesktopTabGroup justified isSingleTab={(tabs?.length === 1)}>
        {tabs
          .map((tab, index) => (
            <BookingWidgetTab
              key={tab.tabLabel}
              label={tab.tabLabel}
              colorProfile={trueColorProfile}
              className={classNames({ active: activeTab === index })}
              onClick={() => setActiveTab(index)}
            />
          ))}
      </StyledDesktopTabGroup>

      {/* Tabs for smaller screens */}
      {tabs
        .map((tab, index) => (
          <BookingWidgetTab
            mobile
            isSingleTab={(tabs?.length === 1)}
            key={tab.tabLabel}
            label={tab.tabLabel}
            colorProfile={trueColorProfile}
            className={classNames({ active: activeTab === index })}
            onClick={() => setActiveTab(index)}
          >
            <TabContent
              is5050={is5050}
              active={activeTab === index}
              tab={tab}
              colorProfile={trueColorProfile}
            />
          </BookingWidgetTab>
        ))}
    </StyledBookingWidget>
  );
};

BookingWidget.propTypes = {
  relationships: PropTypes.shape().isRequired,
  colorProfile: PropTypes.string,
  parentColorProfile: PropTypes.string,
  is5050: PropTypes.bool,
};

BookingWidget.defaultProps = {
  colorProfile: null,
  parentColorProfile: null,
  is5050: false,
};
